import { Button, Card, CardContent, Grid, CardHeader } from "@mui/material";
import { useState } from "react";
import { apiConstants, getGeneric, postGeneric } from '../../common/constants'
import * as React from 'react'
import PageTitle from "../../components/PageTitle";
import { useSnackbar } from "notistack";
import Loader from "../../common/Loader";
import { useForm } from "react-hook-form";
import { FormProvider, RHFSelectField, RHFTextField } from "../../common/hook-form";
import { LoadingButton } from "@mui/lab";
import { MerchantFilterCached } from "../../common/ProshipFormComponents";
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

function InsuranceConfig({ title }) {
    const [loading, setLoading] = useState(false)
    const { enqueueSnackbar } = useSnackbar();

    const validationSchema = Yup.object().shape({
        merchant: Yup.string().required('Merchant is required'),
        insuranceEnabled: Yup.string().required('Insurance enabled is required'),
      
        autoEnabledForMinInvoiceValue: Yup.string().when('insuranceEnabled', {
          is: 'true',
          then: Yup.string()
            .required('Min invoice value is required when insurance is enabled')
            .matches(/^\d*\.?\d*$/, 'Must be a valid number'),
          otherwise: Yup.string().nullable()
        }),
      
        flatCharges: Yup.string()
          .matches(/^\d*\.?\d*$/, 'Must be a valid number')
          .nullable(),
      
        percentOfInvoice: Yup.string()
          .matches(/^\d*\.?\d*$/, 'Must be a valid number')
          .nullable(),
      
      }).test(
        'flat-or-percent-required',
        'Either Flat Charges or Percent of Invoice is required when insurance is enabled (only one can be filled)',
        function (values) {
          const { insuranceEnabled, flatCharges, percentOfInvoice } = values;
      
          if (insuranceEnabled !== 'true') return true;
      
          const hasFlat = !!flatCharges?.trim();
          const hasPercent = !!percentOfInvoice?.trim();
      
          if (!hasFlat && !hasPercent) return this.createError({
            path: 'flatCharges', // or 'percentOfInvoice'
            message: 'Either Flat Charges or Percent of Invoice must be filled',
          });
      
          if (hasFlat && hasPercent) return this.createError({
            path: 'flatCharges',
            message: 'Only one of Flat Charges or Percent of Invoice should be filled',
          });
      
          return true;
        }
      );
      

    const methods = useForm({
        defaultValues: {
            merchant: '',
            insuranceEnabled: '',
            autoEnabled: '',
            autoEnabledForMinInvoiceValue: '',
            flatCharges: '',
            percentOfInvoice: '',
        },
        resolver: yupResolver(validationSchema)
    });

    const {
        handleSubmit,
        reset,
        watch,
        setValue,
    } = methods;

    const onSubmit = (data) => {
        const payload = {
            insuranceEnabled: data.insuranceEnabled,
            autoEnabled: data.autoEnabled,
            autoEnabledForMinInvoiceValue: data.autoEnabledForMinInvoiceValue,
            flatCharges: data.flatCharges,
            percentOfInvoice: data.percentOfInvoice,
        }
        postGeneric(`${apiConstants.MERCHANT_DETAILS}/${data.merchant}/insurance/config`, payload).then((res) => {
            enqueueSnackbar("Success", { variant: 'success' });
            reset();
            setLoading(false)
        }).catch((err) => {
            setLoading(false)
            enqueueSnackbar("Some error occurred", { variant: 'error' });
        })
    }

    const merchantInfo = watch('merchant');

    React.useEffect(() => {
        if (merchantInfo) {
            getGeneric(`${apiConstants.MERCHANT_DETAILS}/${merchantInfo}`).then((res) => {
                const data = res.data?.insuranceEnabled;
                setValue('insuranceEnabled', data?.insuranceEnabled);
                setValue('autoEnabledForMinInvoiceValue', data?.autoEnabledForMinInvoiceValue);
                setValue('flatCharges', data?.flatCharges);
                setValue('autoEnabled', data?.autoEnabled);
                setValue('percentOfInvoice', data?.percentOfInvoice);
            })
        }
    }, [merchantInfo])


    const insuranceEnabledOptions = [
        { value: true, label: 'True' },
        { value: false, label: 'False' },
    ]

    // const autoEnabledOptions = [
    //     { value: true, label: 'True' },
    //     { value: false, label: 'False' },
    // ]

    return (
        <>
            <PageTitle>Insurance Config</PageTitle>
            <Card sx={{ mb: 2 }}>
                {loading && <Loader />}
                <CardHeader title={title} />
                <CardContent>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item xs={4}>
                                <MerchantFilterCached name="merchant" label="Select Merchant" />
                            </Grid>
                            <Grid item xs={4}>
                                <RHFSelectField
                                    width="100%"
                                    name="insuranceEnabled"
                                    label={`Insurance Enabled`}
                                    options={insuranceEnabledOptions}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <RHFSelectField
                                    width="100%"
                                    name="autoEnabled"
                                    label={`Auto insurance with shipment`}
                                    options={insuranceEnabledOptions}
                                />
                            </Grid>
                            {/* <Grid item xs={4}>
                                <RHFSelectField
                                    width="100%"
                                    name="autoEnabled"
                                    label={`Auto Enabled`}
                                    options={autoEnabledOptions}
                                />
                            </Grid> */}
                            <Grid item xs={4}>
                                <RHFTextField
                                    width="100%"
                                    name="autoEnabledForMinInvoiceValue"
                                    label={`Min Invoice Value`}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <RHFTextField
                                    width="100%"
                                    name="flatCharges"
                                    label={`Flat Charges`}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <RHFTextField
                                    width="100%"
                                    name="percentOfInvoice"
                                    label={`Percent of Invoice`}
                                />
                            </Grid>
                            <Grid item xs={8}>
                                <LoadingButton
                                    variant="contained"
                                    sx={{ ml: 1 }}
                                    size="small"
                                    type="submit"
                                >
                                    Submit
                                </LoadingButton>
                                <Button
                                    sx={{ ml: 1 }}
                                    variant="contained"
                                    color="error"
                                    size="small"
                                    onClick={() => { reset(); }}
                                >
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </FormProvider>
                </CardContent>
            </Card>
        </>
    );
}


export default InsuranceConfig;